import React from 'react'
import { Box, Typography } from '@mui/material';

const OfferHeader = ({ h1, h2, location, hideLocation }) => (
  <Box px={2} py={1}>
    <Typography variant="h5" component="h3" noWrap style={{ fontSize: 20, fontWeight: 500, lineHeight: 1.2, overflow: 'hidden', textOverflow: 'ellipsis' }}>
      {h1}
    </Typography>
    <Typography variant="h6" component="h4" style={{ fontSize: 16, fontWeight: 400 }}>
      {h2}
    </Typography>
    {!hideLocation && (
      <Typography variant="body2" color="primary">
        {location || 'Global'}
      </Typography>
    )}
  </Box>
)

export default OfferHeader
